<template>
  <div class="sort-row">
    <div class="sort-row__search"
         :class="isSearchOpen ? '_open' : null">

      <transition name="expand-left">
        <div
             class="sort-row__search-inner"
             v-if="isSearchOpen"
             v-click-out="isSearchOpen || search.length == 0 ? searchToggleOpen : null">

          <BaseInput v-model="search"
                     name="search"
                     @change="changeSearch"
                     ref="searchInput"
                     @keypress.native.enter.prevent="searchBtn"
                     class="sort-row__search-input _white"
          />

          <span class="sort-row__search-cancel" @click.prevent="closeSearch" v-if="search.length > 0">
            <svg>
              <use xlink:href="#select-ico-close"></use>
            </svg>
          </span>
        </div>
      </transition>

       <button type="button"
              @click.prevent="searchBtn"
              :class="`sort-row__search-${isSearchOpen ? 'submit' : 'btn'} base-btn base-btn--white`">
          <BaseSvg name="ico-loupe" width="1.2rem" height="1.2rem"/>
        </button>

    </div>
    <div class="sort-row__select-wrap">
      <BaseSelect :value="sort"
                  :options="sortList"
                  :getOptionText="getOptionTextSort"
                  @input="onSortInput"
                  class="sort-row _white _shadow-full"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: "SortRowVacancies",
    props: {
      tab: {
        type: Number,
        default: 0
      },
      sort: {
        type: String,
        required: true,
      },
      sortList: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        isSearchOpen: false,
        total: 0,
        perPage: 0,
        filterCheckbox: {
          value: false
        },
        search: '',
        queryNamePage: 'page',
        queryParamsNames: ['search_query', 'page', 'country_id', 'city_id', 'category_id', 'salary_from', 'salary_to', 'housing_type', 'schedule_type', 'order_by', 'direct_vacancies']

      }
    },
    computed: {
      page() {
        return this.$route.query[this.queryNamePage] || 1
      },
      pagesCount() {
        return Math.ceil(this.total / this.perPage) || 0
      },
      queryParams() {
        const params = {}

        for (let name of this.queryParamsNames) {
          let value = this.$route.query[name]
          if (value) {
            params[name] = value
          }
        }

        return params
      }
    },

    mounted() {
      this.checkOpen()
    },

    watch: {
      "$route": {
        deep: true,
        immediate: true,
        handler() {
          this.checkOpen()
        }
      },
      isSearchOpen() {
        if (this.isSearchOpen) {
          setTimeout(() => {
            if (this.$refs.searchInput) {
              this.$refs.searchInput.$refs.input.focus()
            }
          }, 100);
        }
      }
    },

    methods: {
      closeSearch() {
        this.search = ''
        let query = {...this.$route.query}
        delete query.search_query
        this.$router.push({query})
      },
      changeSearch(val) {
        if (!val.length) {
          this.$router.replace({'query': null})
          this.isSearchOpen = false
        }
      },
      checkOpen() {
        if (this.$route.query.search_query) {
          this.search = this.$route.query.search_query
          this.isSearchOpen = true
        }
        if (this.search.length) {
          this.isSearchOpen = true
        }
      },
      searchToggleOpen() {
        if (!this.$route.query.search_query || !this.search.length)
          this.isSearchOpen = !this.isSearchOpen
      },
      searchBtn() {
        if (this.isSearchOpen && this.search !== this.$route.query.search_query) {
          this.onSearch()
        }

        if (!this.isSearchOpen ){
           this.searchToggleOpen()
        }
      },
      onSortInput(value) {
        if (value === this.sortList[0]) {
          return this.$router.replace({ query: { ...this.$route.query, order_by: undefined } }).catch(() => {})
        } else {
          return this.$router.push({ query: { ...this.$route.query, order_by: value } }).catch(() => {})
        }
      },
      getOptionTextSort(option) {
        return this.$tVacancies(option)
      },
      onSearch() {
        if (this.search.length > 2) {
          this.$router.push({ query: { ...this.$route.query, search_query: this.search } })
          this.isSearchOpen = true
        }
      },
    }

  }
</script>

<style scoped>

</style>
